import { Check } from 'lucide-react';
import {Cellule} from "../../types/cellule";
import React, {ReactNode, useEffect, useState} from "react";
import {useDisclosure} from "@mantine/hooks";
import ajax from "../../services/AxiosInterceptor";
import {Modal, TextInput} from "@mantine/core";
import {LoadingButton} from "../../components/loading_button/loading_button";
import {Organisation} from "../../types/organisation";
import {notifications} from "@mantine/notifications";
import env_config from "../../env_config";

export function Modale_editer_texte({
                                      modal_titre,
                                      texte, onValidation, onClose
                                  }: { modal_titre:string, texte:string|null, onValidation: (texte:string) => Promise<void>, onClose: () => void }) {
    const [opened, handlers] = useDisclosure(false);
    const [save_btn_loading, set_save_btn_loading] = useState(false);
    const [texte_edit, set_texte_edit] = useState(texte);

    // if (forcer) handlers.open();
    useEffect(() => {
        if (texte === null) handlers.close();
        else {
            handlers.open();
            set_texte_edit(texte);
        }
    }, [texte])

    function handleEnregistrer() {
        set_save_btn_loading(true);
        onValidation(texte_edit ?? "").then(response => {
            set_save_btn_loading(false);
            handleClose();
        })
    }

    function handleClose(){

        onClose();
        //handlers.close();
    }

    // if (!organisation) return <></>

    return (
        <>
            <Modal opened={opened} onClose={handleClose} title={modal_titre} zIndex={100000}>
                <div className={"form"}>
                    <TextInput type="text" value={texte_edit??""} onChange={event => set_texte_edit(event.target.value)}/>
                    <LoadingButton is_loading={save_btn_loading}
                                   onClick={handleEnregistrer}>Enregistrer</LoadingButton>
                </div>
            </Modal>
        </>

    )
}